"use strict";
/** Common primitives shared across DTOs. */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=common.js.map